var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","timeout":5000,"color":_vm.$props.type},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._l((_vm.$props.messages),function(message,index){return [_vm._v(" • "+_vm._s(message)+" "),_c('br',{key:index})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }